(() => {
  if (window.__pdpUpsellLoaded) return;
  window.__pdpUpsellLoaded = true;

  const root = document.querySelector('[data-pdp-upsell]');
  const dataEl = root?.querySelector('[data-pdp-upsell-json]');

  let config = {};
  if (dataEl) {
    try {
      config = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.error('[pdp-upsell] bad JSON', e);
      config = {};
    }
  }

  const designMode = Boolean(window.Shopify?.designMode);

  function go(url) {
    let parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return;
    }
    if (parsed.origin !== window.location.origin) return;
    const path = (parsed.pathname + parsed.search + parsed.hash).replace(/[<>"']/g, '');
    if (!path.startsWith('/')) return;
    window.location.assign(path);
  }

  function homeUrl() {
    return config.homeUrl || window.Shopify?.routes?.root || '/';
  }

  if (config.offerFlowOnly && !config.cartHasMain && !designMode) {
    go(homeUrl());
    return;
  }

  if (!root || !config.enabled) return;

  const declineWrap = root.querySelector('[data-pdp-upsell-decline-bar]');
  const declineBtn = root.querySelector('[data-pdp-upsell-decline]');

  let handling = false;

  function resolveOfferUrl(entry) {
    if (!entry) return '';
    if (entry.url) return entry.url;
    if (entry.handle) {
      const shopRoot = window.Shopify?.routes?.root || '/';
      return `${shopRoot}products/${entry.handle}`;
    }
    return '';
  }

  function closeCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    const dialog =
      drawer?.querySelector('dialog') ||
      drawer?.closest('dialog') ||
      document.querySelector('#cart-drawer dialog');
    if (dialog?.open) dialog.close();
  }

  function cartUrl() {
    const offer = readOfferFromUrl();
    return offer?.cartUrl || config.cartUrl || '/cart';
  }

  function readOfferFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const stage = params.get('pdp_offer');
    if (stage !== 'upsell' && stage !== 'downsell') return null;

    return {
      stage,
      cartUrl: params.get('pdp_cart') || config.cartUrl || '/cart',
    };
  }

  function buildOfferUrl(baseUrl, stage) {
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('pdp_offer', stage);
    url.searchParams.set('pdp_cart', cartUrl());
    return url.toString();
  }

  function placeUnderAddToCart() {
    if (!declineWrap) return;

    const details =
      document.querySelector('.product-details') ||
      document.querySelector('.product-information__details') ||
      document.querySelector('[id*="ProductInformation"]');

    const scope = details || document;
    const addToCartButton = scope.querySelector(
      '.product-form-buttons .add-to-cart-button, product-form-component .add-to-cart-button'
    );

    if (addToCartButton) {
      const host = addToCartButton.closest('.product-form-buttons > *') || addToCartButton;
      host.insertAdjacentElement('afterend', declineWrap);
      return;
    }

    const buyButtons = scope.querySelector('.buy-buttons-block');
    if (buyButtons) {
      buyButtons.insertAdjacentElement('afterend', declineWrap);
      return;
    }

    if (details) details.appendChild(declineWrap);
  }

  function showDecline(offer) {
    if (!declineWrap || !declineBtn) return;

    const label =
      offer.stage === 'downsell'
        ? config.copy?.declineDownsell || 'No thanks'
        : config.copy?.declineUpsell || 'No thanks';

    declineBtn.textContent = label;
    placeUnderAddToCart();
    declineWrap.hidden = false;
    declineWrap.classList.add('is-visible');
  }

  function handleDecline() {
    const offer = readOfferFromUrl();
    if (!offer) return;

    const downsellUrl = resolveOfferUrl(config.downsell);
    if (downsellUrl) {
      go(buildOfferUrl(downsellUrl, 'downsell'));
      return;
    }

    go(cartUrl());
  }

  function continueOrEndChain(nextUrl, stage) {
    closeCartDrawer();
    if (nextUrl) {
      go(buildOfferUrl(nextUrl, stage));
      return;
    }
    go(cartUrl());
  }

  const BASE_SKU = String(config.upgrade?.baseSku || '90RT02GRT01');
  const PLATINUM_SKU = String(config.upgrade?.platinumSku || '90RT02GRTP01');
  const DIRECT_TO_CART_SKUS = ['90RT01DS01', '30RT01RBP01'];

  function normalizeSku(sku) {
    return String(sku || '').trim().toUpperCase();
  }

  function cartChangeUrl() {
    const route = window.Theme?.routes?.cart_change_url || '/cart/change.js';
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function fetchCart() {
    const base = window.Theme?.routes?.cart_url || '/cart';
    const url = base.endsWith('.json') || base.endsWith('.js') ? base : `${base}.js`;
    return fetch(`${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch cart (${response.status})`);
      return response.json();
    });
  }

  function cartStillHasBase(cart) {
    return (cart?.items || []).some((item) => normalizeSku(item.sku) === BASE_SKU);
  }

  function cartHasPlatinum(cart) {
    return (cart?.items || []).some((item) => normalizeSku(item.sku) === PLATINUM_SKU);
  }

  function changeLineQuantity(id, quantity) {
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id, quantity }),
    }).then(async (response) => {
      const data = await response.json().catch(() => null);
      const statusCode = Number(data?.status);
      const cartError = !response.ok || data?.errors || (statusCode >= 400 && !Array.isArray(data?.items));
      if (cartError) {
        throw new Error(data?.description || data?.message || `Cart change failed (${response.status})`);
      }
      return data;
    });
  }

  function syncHeaderCartCount(cart) {
    const count = Number(cart?.item_count);
    if (!Number.isFinite(count) || count < 0) return;

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: String(count),
          timestamp: Date.now(),
        })
      );
    } catch (_) {
      // no-op
    }

    document.querySelectorAll('cart-icon').forEach((icon) => {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(count, false);
      }
    });
  }

  function removeBaseSkuLines(cart) {
    const baseLines = (cart?.items || []).filter((item) => normalizeSku(item.sku) === BASE_SKU && item.key);
    if (!baseLines.length) return Promise.resolve();

    window.__pdpUpgradeReplacing = true;
    return baseLines
      .reduce(
        (chain, item) =>
          chain.then(() =>
            changeLineQuantity(item.key, 0).catch(() => {
              const variantId = item.variant_id || item.id;
              if (variantId == null || String(variantId) === String(item.key)) throw new Error('Cart change failed');
              return changeLineQuantity(variantId, 0);
            })
          ),
        Promise.resolve()
      )
      .then(() => fetchCart())
      .then((updated) => {
        if (cartStillHasBase(updated)) throw new Error('Base SKU is still in the cart');
        syncHeaderCartCount(updated);
      })
      .catch((error) => {
        window.__pdpUpgradeReplacing = false;
        throw error;
      });
  }

  function replaceBaseWhenPlatinumAdded() {
    return fetchCart().then((cart) => {
      if (!cartHasPlatinum(cart) || !cartStillHasBase(cart)) return Promise.resolve();
      return removeBaseSkuLines(cart);
    });
  }

  function productSellsDirectToCart() {
    const skus = Array.isArray(config.variantSkus) ? config.variantSkus : [];
    return skus.some((sku) => DIRECT_TO_CART_SKUS.includes(normalizeSku(sku)));
  }

  function startFunnelFromConfig() {
    if (productSellsDirectToCart() && !readOfferFromUrl()) {
      closeCartDrawer();
      go(cartUrl());
      return;
    }
    continueOrEndChain(resolveOfferUrl(config.upsell), 'upsell');
  }

  function onAddToCartSuccess(detail, event) {
    if (handling) return;
    if (detail?.didError) return;

    const source = detail?.source || detail?.data?.source;
    if (source && source !== 'product-form-component') return;

    handling = true;
    replaceBaseWhenPlatinumAdded()
      .catch((error) => {
        console.warn('[pdp-upsell] base SKU was not removed:', error);
      })
      .finally(() => {
        startFunnelFromConfig();
      });
  }

  function onCartLinesUpdate(event) {
    if (handling) return;
    if (event.action && event.action !== 'add') return;
    if (event.context && event.context !== 'product') return;

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise
        .then((result) => onAddToCartSuccess(result?.detail, event))
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[pdp-upsell] cart update rejected:', error);
        });
      return;
    }

    onAddToCartSuccess(event.detail?.data || event.detail, event);
  }

  const offerOnLoad = readOfferFromUrl();
  if (offerOnLoad) {
    showDecline(offerOnLoad);
  }

  declineBtn?.addEventListener('click', handleDecline);

  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);
  document.addEventListener('cart:update', onCartLinesUpdate);
})();
